export enum Signable {
  Y = 'Y',
  N = 'N'
}

export enum SignatureStatus {
  UNSIGNED = 'UNSIGNED',
  PENDING = 'PENDING',
  SIGNED = 'SIGNED',
  ERROR = 'ERROR',
  OK = 'OK',
  USER_CANCELLED = 'USER_CANCELLED',
  CRL_ERROR = 'CRL_ERROR',
  OCSP_ERROR = 'OCSP_ERROR',
  SIGNER_NOT_EXPECTED_ONE = 'SIGNER_NOT_EXPECTED_ONE',
  APP_ERROR = 'APP_ERROR'
}

export class InboxAttachment {

  filename: string;
  mimeType: string;
  attachment: string[];
  signable: Signable;
  signatureStatus: SignatureStatus;
  inboxMessageId?: string;
  id?: string;

  constructor(filename: string,
              mimeType: string,
              attachment: string[],
              signable: Signable,
              signatureStatus: SignatureStatus,
              inboxMessageId?: string,
              id?: string) {
    this.filename = filename;
    this.mimeType = mimeType;
    this.attachment = attachment;
    this.signable = signable;
    this.signatureStatus = signatureStatus;
    this.inboxMessageId = inboxMessageId;
    this.id = id;
  }
}
